import axios from "axios";

export default {
  async getUsers() {
    return axios.get("/api/users");
  },
  async updateUser(user) {
    return axios.patch("/api/users", user);
  },
  async deleteUser(user) {
    // Only name is required, eg: {"name":"bill"}
    return axios.delete("/api/users", { data: user });
  },
  async createUser(user) {
    return axios.post("/api/users", user);
  },
  async getRoles() {
    return axios.get("/api/users/roles");
  },
  async updatePassword(password) {
    return axios.post("/api/users/password", password);
  },
  async resetPassword(user) {
    return axios.post("/api/users/password/reset", user);
  },
};
